import {ValueObject} from '@s-ui/domain'

import {CityLocationEntity} from '../Entities/CityLocationEntity.js'
import {ProvincesLocationValueObject} from './ProvincesLocationValueObject.js'
import {RegionLocationValueObject} from './RegionLocationValueObject.js'

export class LocationValueObject extends ValueObject {
  #city
  #provinces
  #region

  constructor({city, provinces, region}) {
    super()
    this.#city = city
    this.#provinces = provinces
    this.#region = region
  }

  static createFromListingApi({location}) {
    return new LocationValueObject({
      city: CityLocationEntity.createFromLiterals({id: location.cityId, name: location.cityLiteral}),
      provinces: ProvincesLocationValueObject.createFromListingApi({
        mainProvince: location.mainProvince,
        mainProvinceId: location.mainProvinceId,
        provinceIds: location.provinceIds
      }),
      region: RegionLocationValueObject.createFromLiterals({id: location.regionId, name: location.regionLiteral})
    })
  }

  get city() {
    return this.#city.value
  }

  get provinces() {
    return this.#provinces.value
  }

  get region() {
    return this.#region.value
  }

  hasMultipleProvinces() {
    return this.#provinces.hasMultipleProvinces()
  }

  get value() {
    return {
      hasMultiProvince: this.hasMultipleProvinces(),
      provinces: this.provinces,
      ...(!this.#city.isEmpty() && {city: this.city}),
      ...(!this.#region.isEmpty() && {region: this.region})
    }
  }
}
